import { Component } from "react";
import ListingWebServices from "../service/listing_web_services";
import ProposalServices from "../service/proposal_web_services";
import QuotaionServices from "../service/quotation_service";
import DataResult from "../data/bean/data_result";
import Config from "../Config";
import LanguageBloc from "./language_bloc";
import Labels from "../ui/constant/labels";
import UtilBloc from "./util_bloc";
import FormBloc from "./form_bloc";
import AuthBloc from "./auth_bloc";

class QuotationBloc extends Component {
  //getProductListing for quotation
  static isDefaultBusiness(list){
    const session = AuthBloc.checkSession();
    let segment=""
    if(session){
      segment=session.data.meta.metadata.attributes?.subChannel;
      if(list.includes(segment)){
        return true
      }

    } else {
      return false
    }
  }

  static async getProductListing(anb) {
    let resp = await QuotaionServices.getProductListing(anb);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp.data);
    }
  }

  static async getSegmentListing() {
    let resp = await QuotaionServices.getSegmentListing();
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp.data);
    }
  }

  //deleteQuotationById by id quotation
  static async deleteQuotationById(id) {
    let resp = await QuotaionServices.deleteQuotationById(id);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp.data);
    }
  }

  //getQuotationDetail
  static async getQuotationDetail(id) {
    let payload = {
      "id": id,
    };
    let result = {};
    let premium = {
      /* "basicPremium": "107.60",
      "totalPayableAmount": "726.14",
      "ropPremium": "577.44",
      "taxPercentage": "6.00",
      "totalPremium": "685.04",
      "taxes": "41.10",
      "purposeOfProposal": "BP",
      "declaration": "For a life insurance purchased for business purpose, the law requires Service Tax to be imposed on the premium payable. Taxes may be imposed or increased, at any time on any of the premiums due and payable by you under this policy. If so, you shall pay the premium required together with the Taxes at the applicable prevailing rate." */
  };
    await this.calculatePremiumToPay(
      payload
    )
      .then((result) => {
        premium = result.data;
      })
      .catch((e) => { });    
    let response = await ListingWebServices.getListingDetail(payload);
    if (response.success) {            
      result = this.mapQuotationDetail(response, premium);
    }

    return result;
  }

  static async getQuotationDetailWithouCalculate(id) {
    let payload = {
      "id": id,
    };
    let result = {};
    let premium = null;
    
    let response = await ListingWebServices.getListingDetail(payload);
    if (response.success) {
      
      result = this.mapQuotationDetail(response, premium);
    }

    return result;
  }

  //mapQuotationDetail with categories that is undertanded as proposal steps
  static mapQuotationDetail(response, premium) {
    let generatedDocument = [];
    let indexOfPersonalDetails = 0;
    
    indexOfPersonalDetails = response.data.quotationAttrs.findIndex(
      (item) => item.quotation_attr.category === "PERSONAL_DETAILS"
    );

    let indexOfProductSelection = 0;
    indexOfProductSelection = response.data.quotationAttrs.findIndex(
      (item) => item.quotation_attr.category === "PRODUCT_SELECTION"
    );

    let indexOfProductDetails = 0;
    indexOfProductDetails = response.data.quotationAttrs.findIndex(
      (item) => item.quotation_attr.category === "PRODUCT_DETAILS"
    );

    let personalDetailsAttr = response.data.quotationAttrs[indexOfPersonalDetails]

    let productSelectionAttr =response.data.quotationAttrs[indexOfProductSelection]

    let productDetailsAttr =response.data.quotationAttrs[indexOfProductDetails]   
    
    //Getting Quotation Details
    let data = null;
    if (response.data.quotationAttrs.length > 0) {         
      data = {
        status: response.data.quotation.trxStatus,
        refNo: response.data.quotation.refNo,
        clientId:personalDetailsAttr && personalDetailsAttr.quotation_attr.properties ? personalDetailsAttr.quotation_attr.properties.clientId:"",
        productCode:productSelectionAttr.quotation_attr.properties.productSelection.code,
        personalDetails:personalDetailsAttr && personalDetailsAttr.quotation_attr.properties ? {          
          name: {
            caption: Labels.LBL_LIFE_ASSURED_NAME,
            value: personalDetailsAttr.quotation_attr.properties.name,
          },
          gender: {
            caption: Labels.LBL_GENDER,
            value: UtilBloc.convertToLocaleObject(
              personalDetailsAttr.quotation_attr.properties.gender.description,
              personalDetailsAttr.quotation_attr.properties.gender.description1
            ),
          },
          dob: {
            caption: Labels.LBL_DOB,
            value: personalDetailsAttr.quotation_attr.properties.dob,
          },
          anb: {
            caption: Labels.LBL_AGE_ANB,
            value: personalDetailsAttr.quotation_attr.properties.anb,
          },
          occupation: {
            caption: Labels.LBL_OCCUPATION,
            value: UtilBloc.convertToLocaleObject(
              personalDetailsAttr.quotation_attr.properties.occupation.description,
              personalDetailsAttr.quotation_attr.properties.occupation.description1
            ),
          },
          nob: {
            caption: Labels.LBL_NOB,
            value: UtilBloc.convertToLocaleObject(
              personalDetailsAttr.quotation_attr.properties.nob.description,
              personalDetailsAttr.quotation_attr.properties.nob.description1
            ),
          },
          occupationClass: {
            caption: Labels.LBL_OCCUPATION_CLASS,
            value: UtilBloc.convertToLocaleObject(
              personalDetailsAttr.quotation_attr.properties.occupationClass
                .description,
              personalDetailsAttr.quotation_attr.properties.occupationClass
                .description1
            ),
          },
          email: {
            caption: Labels.LBL_EMAIL,
            value: personalDetailsAttr.quotation_attr.properties.email,
          },
          smoked: personalDetailsAttr.quotation_attr.properties.smoked ? {
            caption: Labels.LBL_SMOKED_QUESTION,
            value: UtilBloc.convertToLocaleObject(
              personalDetailsAttr.quotation_attr.properties.smoked.label,
              personalDetailsAttr.quotation_attr.properties.smoked.label == "Yes"
                ? "Ya"
                : "Tidak"
            ),
          } : null,
        } :{},
        productSelection:productSelectionAttr && productSelectionAttr.quotation_attr.properties ? {
          purposeOfProposal: {
            caption: Labels.LBL_PURPOSE_OF_PROPOSAL,
            value: productSelectionAttr.quotation_attr.properties.purposeOfProposal.description,
          },
          productSelection: {
            caption: Labels.LBL_PRODUCT_SELECTION,
            value: productSelectionAttr.quotation_attr.properties.productSelection.description,
          },

          insuranceType:FormBloc.allowToShowNewFields(productSelectionAttr.quotation_attr.properties.productSelection.code) ? {
            caption: Labels.LBL_INSURANCE_TYPE,
            value:productSelectionAttr.quotation_attr.properties.insuranceType ? productSelectionAttr.quotation_attr.properties.insuranceType.description :"-",
          }:{},
          arrangement : FormBloc.allowToShowNewFields(productSelectionAttr.quotation_attr.properties.productSelection.code) ? {
            caption: Labels.LBL_ARRANGEMENT,
            value: productSelectionAttr.quotation_attr.properties.arrangement.label,
          }:{},
          company :FormBloc.allowToShowNewFields(productSelectionAttr.quotation_attr.properties.productSelection.code) ? {
            caption: Labels.LBL_COMPANY_INSURED_MEMBER,
            value: productSelectionAttr.quotation_attr.properties.company ? productSelectionAttr.quotation_attr.properties.company:"-",
          }:{},
          paymentFrequency: {
            caption: Labels.LBL_PAYMENT_FREQUENCY,
            value: UtilBloc.convertToLocaleObject(
              productSelectionAttr.quotation_attr.properties.paymentFrequency.description,
              productSelectionAttr.quotation_attr.properties.paymentFrequency.description1
            )
          },
          paymentMode: {
            caption: Labels.LBL_PAYMENT_MODE,
            value: UtilBloc.convertToLocaleObject(
              productSelectionAttr.quotation_attr.properties?.paymentMode?.label || "-",
              productSelectionAttr.quotation_attr.properties?.paymentMode?.label || "-"
            )
          },
          paymentMethod: {
            caption: Labels.LBL_PAYMENT_METHOD,
            value: UtilBloc.convertToLocaleObject(
              productSelectionAttr.quotation_attr.properties?.paymentMethod?.description || "-",
              productSelectionAttr.quotation_attr.properties?.paymentMethod?.description || "-"
            )
          },
          anb: {
            caption: Labels.LBL_AGE_ANB,
            value: productSelectionAttr.quotation_attr.properties.anb,
          },
          inceptionDate: {
            caption: Labels.LBL_INCEPTION_DATE,
            value: productSelectionAttr.quotation_attr.properties.inceptionDate,
          },   


        } : {},
        productDetails:productDetailsAttr && productDetailsAttr.quotation_attr.properties ? {
          /* loanAccountNo: {
            caption: Labels.LBL_LOAN_ACCOUNT_NO,
            value: productDetailsAttr.quotation_attr.properties.loanAccountNo || "-",
          },
          loanAmount: productDetailsAttr.quotation_attr.properties.loanAmount ? {
            caption: Labels.LBL_LOAN_AMOUNT,
            value: productDetailsAttr.quotation_attr.properties.loanAmount,
            prefix: "RM ",
            suffix: ".00",
          }:null,
          loanInterestRate:productDetailsAttr.quotation_attr.properties.loanInterestRate ? {
            caption: Labels.LBL_LOAN_INTEREST_RATE,
            value: productDetailsAttr.quotation_attr.properties.loanInterestRate,
            type: "number",
            fixed: 2,
            suffix: "%",
          }:null,
          loanTenure:productDetailsAttr.quotation_attr.properties.loanTenure ? {
            caption: Labels.LBL_LOAN_TENURE,
            value: productDetailsAttr.quotation_attr.properties.loanTenure,
            type: "number",
            suffix: parseInt(productDetailsAttr.quotation_attr.properties.loanTenure) > 1 ? " years" : " year",
          }:null,
          defermentTerm:productDetailsAttr.quotation_attr.properties.defermentTerm ? {
            caption: Labels.LBL_DEFERMENT_TERM,
            value: UtilBloc.convertToLocaleObject(
              productDetailsAttr.quotation_attr.properties.defermentTerm.description,
              productDetailsAttr.quotation_attr.properties.defermentTerm.description1
            )
          }:null,
          coverageAmount: {
            caption: Labels.LBL_COVERAGE_AMOUNT,
            value: productDetailsAttr.quotation_attr.properties.coverageAmount,
            prefix: "RM ",
            suffix: ".00",
          },
          certificateTerm: {
            caption: Labels.LBL_CERTIFICATE_TERM,
            value:productDetailsAttr.quotation_attr.properties.certificateTerm,
            type: "number",
              suffix: parseInt(productDetailsAttr.quotation_attr.properties.certificateTerm) > 1 ? " years" : " year",
          },
          refundOfPremiumRider: productDetailsAttr.quotation_attr.properties.refundOfPremiumRider?.code == "7RP3" ? {
            caption: Labels.LBL_REFUND_PREMIUM_RIDER,
            value: premium ? premium.ropPremium : productDetailsAttr.quotation_attr.properties.ropPremium ,
            prefix: (premium ? premium.ropPremium :productDetailsAttr.quotation_attr.properties.ropPremium ) != 0.0 ? "RM " : "",
          } : null,          
          basicPremium: {
            caption: "Basic Plan Single Premium",
            value: premium ? premium.basicPremium : "",
            prefix: (premium ? premium.basicPremium : "") != 0.0 ? "RM " : "",
          },
          totalPremium:{
            caption: "Total Premium",
            value: premium ? premium.totalPremium : "",
            prefix: (premium ? premium.totalPremium : "") != 0.0 ? "RM " : "",
          },     */
          productSelection: {
            caption: Labels.LBL_PRODUCT_SELECTION,
            value: productSelectionAttr.quotation_attr.properties.productSelection.description,
          },  
          loanAccountNo: {
            caption: Labels.LBL_LOAN_ACCOUNT_NO,
            value: productDetailsAttr.quotation_attr.properties.loanAccountNo || "-",
          },
          loanAmount: {
            caption: Labels.LBL_LOAN_AMOUNT,
            value: productDetailsAttr.quotation_attr.properties.loanAmount,
            prefix: "RM ",
            suffix: ".00",
          },
          coverageAmount:productDetailsAttr.quotation_attr.properties.coverageAmount ? {
            caption: Labels.LBL_COVERAGE_AMOUNT,
            value: productDetailsAttr.quotation_attr.properties.coverageAmount,
            prefix: "RM ",
            suffix: ".00",
          }:null,
          certificateTerm:productDetailsAttr.quotation_attr.properties.certificateTerm ? {
            caption: Labels.LBL_CERTIFICATE_TERM,
            value:productDetailsAttr.quotation_attr.properties.certificateTerm?.code || productDetailsAttr.quotation_attr.properties.certificateTerm,
            type: "number",
              suffix: parseInt(productDetailsAttr.quotation_attr.properties.certificateTerm?.code || productDetailsAttr.quotation_attr.properties.certificateTerm) > 1 ? " years" : " year",
          }:null,
          loanTenure: productDetailsAttr.quotation_attr.properties.loanTenure ?{
            caption: Labels.LBL_LOAN_TENURE,
            value: productDetailsAttr.quotation_attr.properties.loanTenure,
            type: "number",
            suffix: parseInt(productDetailsAttr.quotation_attr.properties.loanTenure) > 1 ? " years" : " year",
          }:null,
          defermentTerm:productDetailsAttr.quotation_attr.properties.defermentTerm ? {
            caption: Labels.LBL_DEFERMENT_TERM,
            value: UtilBloc.convertToLocaleObject(
              productDetailsAttr.quotation_attr.properties.defermentTerm.description,
              productDetailsAttr.quotation_attr.properties.defermentTerm.description1
            )
          }:null,
          defermentPeriod:productDetailsAttr.quotation_attr.properties.defermentPeriod ? {
            caption: Labels.LBL_DEFERMENT_PERIOD,
            value: UtilBloc.convertToLocaleObject(
              productDetailsAttr.quotation_attr.properties.defermentPeriod.description,
              productDetailsAttr.quotation_attr.properties.defermentPeriod.description1
            )
          }:null,
          constructionPeriod:productDetailsAttr.quotation_attr.properties.constructionPeriod ? {
            caption: Labels.LBL_CONSTRUCTION_PERIOD,
            value: UtilBloc.convertToLocaleObject(
              productDetailsAttr.quotation_attr.properties.constructionPeriod.description,
              productDetailsAttr.quotation_attr.properties.constructionPeriod.description1
            )
          }:null,
          loanInterestRate:productDetailsAttr.quotation_attr.properties.loanInterestRate ? {
            caption: Labels.LBL_LOAN_INTEREST_RATE,
            value: UtilBloc.calculateInterateRate(productDetailsAttr.quotation_attr.properties.loanInterestRate),
            type: "number",                       
            suffix: "%",
          }:null,
          initialSumAssured:productDetailsAttr.quotation_attr.properties.initialSumAssured ? {
            caption: Labels.LBL_INITIAL_SUM_ASSURED,
            value: productDetailsAttr.quotation_attr.properties.initialSumAssured,
            prefix: "RM ",
            suffix: ".00",
          }:null,          
          defermentTerm:productDetailsAttr.quotation_attr.properties.defermentTerm ? {
            caption: Labels.LBL_DEFERMENT_TERM,
            value: UtilBloc.convertToLocaleObject(
              productDetailsAttr.quotation_attr.properties.defermentTerm.description,
              productDetailsAttr.quotation_attr.properties.defermentTerm.description1
            )
          }:null,
          termOfCoverage:productDetailsAttr.quotation_attr.properties.termOfCoverage ? {
            caption:productSelectionAttr.quotation_attr.properties.productSelection.code=="GMA"? Labels.LBL_TERM_OF_COVERAGE_DEFERMENT_TERM :Labels.LBL_TERM_OF_COVERAGE,
            value: productDetailsAttr.quotation_attr.properties.termOfCoverage,
            type: "number",
            suffix: parseInt(productDetailsAttr.quotation_attr.properties.termOfCoverage) > 1 ? " years" : " year",
          }:null,
          refundOfPremiumRider: productDetailsAttr.quotation_attr.properties.refundOfPremiumRider ? {
            caption: Labels.LBL_REFUND_PREMIUM_RIDER,
            value:productDetailsAttr.quotation_attr.properties.refundOfPremiumRider?.label
          } : null,
          singlePremiumToBeAssured: {
            caption: "Basic Plan Single Premium"/* Labels.LBL_SINGLE_PREMIUM_TO_BE_ASSURED */,
            value: premium ? premium.basicPremium : productDetailsAttr.quotation_attr.properties.basicPremium ,
            prefix: (premium ? premium.basicPremium :productDetailsAttr.quotation_attr.properties.basicPremium) != 0.0 ? "RM " : "",
          },
          totalPremium:{
            caption: "Total Premium",
            value: premium ? premium.totalPremium : "",
            prefix: (premium ? premium.totalPremium : "") != 0.0 ? "RM " : "",
          },   
        } : {}, 
        /* financialDetails: financialDetailsAttr && financialDetailsAttr.quotation_attr.properties ? {
          productSelection: {
            productSelection: {
              caption: Labels.LBL_PRODUCT_SELECTION,
              value: financialDetailsAttr.quotation_attr.properties.productSelection.productSelection.description,
            },
            paymentFrequency: {
              caption: Labels.LBL_PAYMENT_FREQUENCY,
              value: UtilBloc.convertToLocaleObject(
                financialDetailsAttr.quotation_attr.properties.productSelection.paymentFrequency.description,
                financialDetailsAttr.quotation_attr.properties.productSelection.paymentFrequency.description1
              )
            },
            paymentMode: {
              caption: Labels.LBL_PAYMENT_MODE,
              value: UtilBloc.convertToLocaleObject(
                financialDetailsAttr.quotation_attr.properties.productSelection.paymentMode.label,
                financialDetailsAttr.quotation_attr.properties.productSelection.paymentMode.label
              )
            },
            paymentMethod: {
              caption: Labels.LBL_PAYMENT_METHOD,
              value: financialDetailsAttr.quotation_attr.properties.productSelection.paymentMethod ? UtilBloc.convertToLocaleObject(
                financialDetailsAttr.quotation_attr.properties.productSelection.paymentMethod.description,
                financialDetailsAttr.quotation_attr.properties.productSelection.paymentMethod.description1
              ) : "-"
            },
            anb: {
              caption: Labels.LBL_AGE_ANB,
              value: financialDetailsAttr.quotation_attr.properties.productSelection.anb,
            },
            inceptionDate: {
              caption: Labels.LBL_INCEPTION_DATE,
              value: financialDetailsAttr.quotation_attr.properties.productSelection.inceptionDate,
            },            
            inceptionDate: {
              caption: Labels.LBL_INCEPTION_DATE,
              value: financialDetailsAttr.quotation_attr.properties.productSelection.inceptionDate,
            },
          },
          mortgageCover: {
            loanAccountNo: {
              caption: Labels.LBL_LOAN_ACCOUNT_NO,
              value: financialDetailsAttr.quotation_attr.properties.mortgageCover.loanAccountNo || "-",
            },
            loanAmount: {
              caption: Labels.LBL_LOAN_AMOUNT,
              value: financialDetailsAttr.quotation_attr.properties.mortgageCover.loanAmount,
              prefix: "RM ",
              suffix: ".00",
            },
            loanTenure: {
              caption: Labels.LBL_LOAN_TENURE,
              value: financialDetailsAttr.quotation_attr.properties.mortgageCover.loanTenure,
              type: "number",
              suffix: parseInt(financialDetailsAttr.quotation_attr.properties.mortgageCover.loanTenure) > 1 ? " years" : " year",
            },
            defermentTerm: {
              caption: Labels.LBL_DEFERMENT_TERM,
              value: UtilBloc.convertToLocaleObject(
                financialDetailsAttr.quotation_attr.properties.mortgageCover.defermentTerm.description,
                financialDetailsAttr.quotation_attr.properties.mortgageCover.defermentTerm.description1
              )
            },
            constructionPeriod: {
              caption: Labels.LBL_CONSTRUCTION_PERIOD,
              value: UtilBloc.convertToLocaleObject(
                financialDetailsAttr.quotation_attr.properties.mortgageCover.constructionPeriod.description,
                financialDetailsAttr.quotation_attr.properties.mortgageCover.constructionPeriod.description1
              )
            },
            loanInterestRate: {
              caption: Labels.LBL_LOAN_INTEREST_RATE,
              value: financialDetailsAttr.quotation_attr.properties.mortgageCover.loanInterestRate,
              type: "number",
              fixed: 2,
              suffix: "%",
            },
            initialSumAssured: {
              caption: Labels.LBL_INITIAL_SUM_ASSURED,
              value: financialDetailsAttr.quotation_attr.properties.mortgageCover.initialSumAssured,
              prefix: "RM ",
              suffix: ".00",
            },
            productName: {
              caption: Labels.LBL_PRODUCT_NAME,
              value: financialDetailsAttr.quotation_attr.properties.productSelection.productSelection.description,
            },
            defermentTerm: {
              caption: Labels.LBL_DEFERMENT_TERM,
              value: UtilBloc.convertToLocaleObject(
                financialDetailsAttr.quotation_attr.properties.mortgageCover.defermentTerm.description,
                financialDetailsAttr.quotation_attr.properties.mortgageCover.defermentTerm.description1
              )
            },
            termOfCoverage: {
              caption: Labels.LBL_TERM_OF_COVERAGE_DEFERMENT_TERM,
              value: financialDetailsAttr.quotation_attr.properties.mortgageCover.termOfCoverage,
              type: "number",
              suffix: parseInt(financialDetailsAttr.quotation_attr.properties.mortgageCover.termOfCoverage) > 1 ? " years" : " year",
            },
            refundOfPremiumRider: financialDetailsAttr.quotation_attr.properties.mortgageCover.refundOfPremiumRider?.code == "7RP3" ? {
              caption: Labels.LBL_REFUND_PREMIUM_RIDER,
              value: premium ? premium.ropPremium : financialDetailsAttr.quotation_attr.properties.ropPremium ,
              prefix: (premium ? premium.ropPremium :financialDetailsAttr.quotation_attr.properties.ropPremium ) != 0.0 ? "RM " : "",
            } : null,
            singlePremiumToBeAssured: {
              caption: Labels.LBL_SINGLE_PREMIUM_TO_BE_ASSURED,
              value: premium ? premium.basicPremium : financialDetailsAttr.quotation_attr.properties.basicPremium ,
              prefix: (premium ? premium.basicPremium :financialDetailsAttr.quotation_attr.properties.basicPremium) != 0.0 ? "RM " : "",
            }
          }
        } : {},
        generatedDocuments: {
          caption: Labels.LBL_GENERATED_DOCUMENTS,
          data: generatedDocument,
        }, */
        refundOfPremiumRider:productDetailsAttr.quotation_attr.properties.refundOfPremiumRider,
        premium: premium /* ? premium :{
          "basicPremium": financialDetailsAttr.quotation_attr.properties.basicPremium,
          "totalPayableAmount": financialDetailsAttr.quotation_attr.properties.totalPayableAmount,
          "ropPremium": financialDetailsAttr.quotation_attr.properties.ropPremium,
          "taxPercentage": financialDetailsAttr.quotation_attr.properties.taxPercentage,          
          "totalPremium": financialDetailsAttr.quotation_attr.properties.totalPremium,
          "taxes": financialDetailsAttr.quotation_attr.properties.taxes,
} */
      };
    }
    //console.log("DADADA",data)
    return data;
  }

  //createNewQuotation with client id
  static async createNewQuotation(payload) {
    let response = await QuotaionServices.newQuotation(payload);

    if (response.success) {
      return response.data[0]["QUOTATION"]?.id || response.data[0]["quotation"]?.id;
    }
  }

  //mapQuotationPersonalDetailForm
  static mapQuotationPersonalDetailForm(response) {
    let record = {};
    if (response.data.length > 0) {
      record = response.data[0].quotation_attr.properties;
    }    
    return record;
  }

  static mapQuotationFinancingDetailForm(response) {
    let record = {};
    if (response.data.length > 0) {
      record = response.data[0].quotation_attr.properties;;
    }
    return record;
  }

  static mapQuotationTakafulDetailForm(response) {
    let record = {};
    if (response.data.length > 0) {
      record = {
        termOfCoverage:
          response.data[0].quotation_attr.properties.termOfCoverage ?? "",
        initialSumCovered:
          response.data[0].quotation_attr.properties.initialSumCovered ?? "",
        contributionAmount:
          response.data[0].quotation_attr.properties.contributionAmount ?? "",
        contributionMode:
          response.data[0].quotation_attr.properties.contributionMode ?? "",
        contributionType:
          response.data[0].quotation_attr.properties.contributionType ?? "",
      };
    }
    return record;
  }

  //getFormDetailQuotation
  static async getFormDetailQuotation(id, category) {
    let result = {};
    let response = await QuotaionServices.getQuotation(id, category);
    //console.log("data response1", response);
    if (response.success) {
      switch (category) {
        case "PERSONAL_DETAILS":
          result = this.mapQuotationPersonalDetailForm(response);
          break;
        case "FINANCING_DETAILS":
          result = this.mapQuotationFinancingDetailForm(response);
          break;
        case "PRODUCT_SELECTION":
          result = this.mapQuotationFinancingDetailForm(response);
          break;
        case "PRODUCT_DETAILS":
          result = this.mapQuotationFinancingDetailForm(response);
          break;
        case "TAKAFUL_DETAILS":
          result = this.mapQuotationTakafulDetailForm(response);
          break;
        default:
          break;
      }
    }
    return result;
  }

  static async validateQuotation(payload) {
    let resp = await QuotaionServices.validateQuotation(payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp.data);
    }
  }

  //calculatePremiumToPay
  static async calculatePremiumToPay(payload) {
    let resp = await QuotaionServices.calculatePremiumToPay(payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async saveForm(id, category, payload) {
    let resp = await QuotaionServices.saveQuotation(id, category, payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //generateDocuments with id quotation
  static async generateDocuments(id) {
    let resp = await QuotaionServices.generateDocuments(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //getQuotationDoc
  static async getQuotationDoc(id, userType, userId) {
    let resp = await QuotaionServices.getQuotationDoc(id, userType, userId);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //emailQuotation send email quotation to customer to start Customer Flow
  static async emailQuotation(id, payload) {
    let resp = await QuotaionServices.emailQuotation(id, payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //No use
  static getProposalSubmissionUrl(proposalId) {
    return `/portal/${Config.routes.generic.proposal_provide_details}/${proposalId}`;
  }
}

export default QuotationBloc;
